 <ng-container [formGroup]='numberFormGroup'>
   <mat-form-field appearance='outline' id="filter-number">
     <mat-label>{{data.place_holder}}</mat-label>
     <input matInput name="{{data.options.key}}" formControlName='{{data.options.key}}' type='number' />
   </mat-form-field>

 </ng-container>
